/**
 * Definitions:
 *   - leaderboard: The big horizontal advert which fills the whole width.
 *   - mediumRectangle: Vertical advert shows on right side. In mobile it shows
 *                      at the bottom.
 *   - inPostAd: The one sticks on bottom.
 *   - inRead: (??)
 *   - mobileSplashAd: (??)
 *   - firstLeaderboard: Server-side rendered `leaderboard`.
 *   - firstMediumRectangle: Server-side rendered `mediumRectangle`.
 *   - loopLeaderboard: Client-side rendered `leaderboard`.
 *   - loopMediumRectangle: Client-side rendered `mediumRectangle`.
 */

const leaderboard = {
  sizes: [[970, 90], [970, 550], [970, 250], [728, 90], [728, 180],[336,280], [320, 50], [320, 100], [300, 250]],
  sizeMapping: [
    {viewport: [970, 0], sizes:[[728, 90], [728, 180], [970, 90], [970, 250]]},
    {viewport: [0, 0], sizes:[[336,280],[320, 50], [320, 100], [300, 250]]},
  ],
};

const mediumRectangle = {
  sizes: [[300,250],[300,600]],
};

export const defaultProps = {

	// on top
	firstLeaderboard: leaderboard,

	// on looping content
	loopLeaderboard: leaderboard,

	// Right side on destop; Bottom when it's mobile
	firstMediumRectangle: mediumRectangle,

  // Right side on destop; Bottom when it's mobile
	loopMediumRectangle: mediumRectangle,

	inPostAd: {
		sizes: [[1, 1]],
		sizeMapping: [{viewport: [1, 1], sizes: [[1, 1]]}],
	},

  inRead: {
		sizes: [[1, 1]],
		sizeMapping: [{viewport: [1, 1], sizes: [[1, 1]]}],
	},

	mobileSplashAd: {
		sizes: [[320, 460],[320,480]],
	},
};

export const adUnits = {

	/**
	 * she.com
	 */
	'she.com': {
    // homepage
    home: {
			firstLeaderboard: 'she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'she.com_homepage_BTF_set2_300x250',
			mobileSplashAd: 'she.com_splashad_mobile_320x460',
		},

    // channel
    category: {
			firstLeaderboard: 'she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'she.com_channels_BTF_set2_300x250',
			mobileSplashAd: 'she.com_splashad_mobile_320x460',
		},

    // article
    single: {
			firstLeaderboard: 'she.com_article_ATF_970x90',
			firstMediumRectangle: 'she.com_article_ATF_300x250',
			loopLeaderboard: 'she.com_article_ATF_970x90',
			loopMediumRectangle: 'she.com_article_ATF_300x250',
			mobileSplashAd: 'she.com_splashad_mobile_320x460',
			inRead: 'she.com_inread_ATF_1x1',
			inPostAd: 'she.com_inPostAd_BTF_300x250',
		},

    // search
		search: {
			firstLeaderboard: 'she.com_homepage_ATF_expand_970x90',
		},

    // tag
		term: {
      firstLeaderboard: 'she.com_homepage_ATF_expand_970x90',
      firstMediumRectangle: 'she.com_article_ATF_300x250',
      loopLeaderboard: 'she.com_article_ATF_970x90',
      loopMediumRectangle: 'she.com_article_ATF_300x250',
		},


    // author
		author: {
			firstLeaderboard: 'she.com_channels_ATF_expand_970x90',
			firstMediumRectangle: 'she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'she.com_channels_ATF_expand_970x90',
			loopMediumRectangle: 'she.com_channels_BTF_set2_300x250',
		},

    // she-promotes
    'she-promotes': {
			firstLeaderboard: 'she.com_channels_ATF_expand_970x90',
			firstMediumRectangle: 'she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'she.com_channels_ATF_expand_970x90',
			loopMediumRectangle: 'she.com_channels_BTF_set2_300x250',
		},
	},

	/**
	 * shemom.com
	 */
	'shemom.com': {
    // homepage
    home: {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			mobileSplashAd: 'shemom.com_splashad_mobile_320x460',
		},

    // channel
    category: {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'shemom.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'shemom.com_channels_BTF_set2_300x250',
			mobileSplashAd: 'shemom.com_splashad_mobile_320x460',
		},

    // article
    single: {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			mobileSplashAd: 'shemom.com_splashad_mobile_320x460',
			inRead: 'shemom.com_inread_ATF_1x1',
			inPostAd: 'shemom.com_inPostAd_BTF_300x250',
		},

    // search
		search: {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
		},

    // tag
		term: {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
		},

    // author
		author: {
			firstLeaderboard: 'shemom.com_other_ATF_970x90',
			firstMediumRectangle: 'shemom.com_other_ATF_300x250',
			loopLeaderboard: 'shemom.com_other_BTF_970x90',
			loopMediumRectangle: 'shemom.com_other_BTF_300x250',
		},

    // she-promotes
    'she-promotes': {
			firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
			loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
		},

	// she-trials
	'she-trials': {
		firstLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
		firstMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
		loopLeaderboard: 'shemom.com_homepage_ATF_expand_970x90',
		loopMediumRectangle: 'shemom.com_homepage_BTF_set2_300x250',
		},
	},



	/**
	 * brides.she.com
	 */
	'brides.she.com': {
    // homepage
    home: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			mobileSplashAd: 'brides.she.com_splashad_mobile_320x460',
		},

    // channel
    category: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			mobileSplashAd: 'brides.she.com_splashad_mobile_320x460',
		},

    // article
    single: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			mobileSplashAd: 'brides.she.com_splashad_mobile_320x460',
			inRead: 'brides.she.com_inread_ATF_1x1',
			inPostAd: 'brides.she.com_inPostAd_BTF_300x250',
		},

    // search
		search: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
		},

    // tag
		term: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
		},

    // author
		author: {
			firstLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			firstMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
			loopLeaderboard: 'brides.she.com_homepage_ATF_expand_970x90',
			loopMediumRectangle: 'brides.she.com_channels_BTF_set2_300x250',
		},

    // she-promotes
    'she-promotes': {
			firstLeaderboard: 'brides.she.com_other_ATF_970x90',
			firstMediumRectangle: 'brides.she.com_other_ATF_300x250',
			loopLeaderboard: 'brides.she.com_other_BTF_970x90',
			loopMediumRectangle: 'brides.she.com_other_BTF_300x250',
		},
	},
};



// WEBPACK FOOTER //
// ./src/Advert/config.js